
// API configuration for different environments
const API_BASE_URL = 'https://DABS-scraper.onrender.com';

export const apiConfig = {
  baseUrl: API_BASE_URL,
  endpoints: {
    search: `${API_BASE_URL}/api/search`,
    savedSearches: `${API_BASE_URL}/api/saved-searches`,
    stripe: {
      createCheckout: `${API_BASE_URL}/api/stripe/create-checkout`,
      checkSubscription: `${API_BASE_URL}/api/stripe/check-subscription`,
      customerPortal: `${API_BASE_URL}/api/stripe/customer-portal`,
    }
  }
};

// Helper function to build full API URLs
export const buildApiUrl = (path: string): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_BASE_URL}/${cleanPath}`;
};
